import React, { useEffect } from "react";
import "./Onestep.css";
import Globe from "../../Images/Globe";
import Geo from "../../Images/Geo";
import Code from "../../Images/Code";
import Cloud from "../../Images/Cloud";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const Onestep = () => {
  const navigate = useNavigate();

  const data = [
    {
      icon: Globe,
      title: "IT Consulting  ",
      className: "",
      onclick: () => {
        navigate("/servicepage/itconsulting");
      },
    },
    {
      icon: Geo,
      title: "IT Services",
      className: "stroke-clr",
      onclick: () => {
        navigate("/servicepage/itservices");
      },
    },
    {
      icon: Code,
      title: "Mobile & Website Development",
      className: "stroke-clr",
      onclick: () => {
        navigate("/servicepage/mobileappandwebdevelopment");
      },
    },
    {
      icon: Cloud,
      title: "Cloud Infrastructure",
      className: "",
      onclick: () => {
        navigate("/servicepage/cloudservices");
      },
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 200,
      easing: "ease-in-out",
    });

    window.addEventListener("load", AOS.refresh);
  }, []);

  return (
    <div
      style={{
        width: "85%",
        margin: "auto",
        // position: "sticky",
        alignContent: "center",
        // top: "0",
      }}
      data-aos="fade-down"
      data-aos-duration="1200"
    >
      <h1
        style={{
          textAlign: "center",
          color: "#fff",
          fontSize: window.innerWidth <= 768 ? "20px" : "30px",
        }}
      >
        One-stop shop under one roof
      </h1>
      <div className="heading-img">
        <h1 style={{ color: "#fff", textAlign: "center", fontSize: "20px" }}>Owision</h1>
      </div>
      <div className="onestep-card">
        {data.map((items, index) => {
          return (
            <div
              className="cards-step"
              key={index}
              onClick={items.onclick}
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <div className="hoverable-card"></div>
                <div className="cards-step-content">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="arrow-container">
                      <div className="arrow"></div>
                      <div className="arrow-stick"></div>
                    </div>
                  </div>
                  <div
                    style={{ marginBottom: window.innerWidth ? "2rem" : "5rem" }}
                    className={items.className}
                  >
                    {items.icon && <items.icon />}
                  </div>
                  <div style={{ fontSize: "20px", fontWeight: 500, color: "#fff" }}>
                    {items.title}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Onestep;
